// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1GZBJ","name":"Header_name__3l254","birthday":"Header_birthday__BeV3r","skeleton":"Header_skeleton__2ydTQ"};